import React, { useState, useEffect } from 'react';
import Select, { components } from 'react-select';
import Checkbox from '#/components/Checkbox/index';

import styles from './styles.module.css';

import { useTranslation } from "react-i18next";


const customStyles = {
  menuList: (provided, state) => ({
    ...provided,
    padding: '0px',
    margin: '0px',
    borderTop: 'none',
    borderLeft: '1px solid #707070',
    borderRight: '1px solid #707070',
    borderBottom: '1px solid #707070',
  }),
  control: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    borderRadius: 'none',
    border: `1px solid #${state.isFocused ? '707070' : 'e5e5e5'}`,
    borderColor: 'green',
    '&:hover': {
      borderColor: '#707070'
    }
  }),
  menu: (provided, state) => ({
    ...provided,
    boxShadow: 'none',
    margin: '0px'
  }),
  dropdownIndicator: (provided, state) => ({
    ...provided,
    borderLeft: `1px solid #${state.isFocused ? '707070' : 'e5e5e5'}`
  }),
  option: (provided, state) => ({
    //
  })
}

function MultiSelectStatic({ selectedItems, title, onSelect, openMenu = false, placeHolder = '', fetchItems, interceptRequest, viewOnlyItemsId = [], isMultiple = true, closeOnSelect = false, disabled = false}) {
  
  const { t } = useTranslation();

  let isGroupSelection = false;
  
  const mapItemsToLabelValue = (data) => {
    if(data === null || data === undefined || data.length <= 0) return [];

    if (data.content) {
      let arrayStandart = data.content.filter((dashboard) => dashboard.type === 1);
      let arrayShared = data.content.filter((dashboard) => dashboard.type === 2);
      isGroupSelection = true;

      let dataContent = [];
      if (arrayStandart.length)
        dataContent = dataContent.concat({
          label: t('STANDARD'),
          options: arrayStandart.map((item) => { return { 'value': +item.id, 'label': item.name } })
        });

      if (arrayShared.length)
        dataContent = dataContent.concat({
          label: t('SHARED'),
          options: arrayShared.map((item) => { return { 'value': +item.id, 'label': item.name } })
        });

      return dataContent;
    }   

    return data.map(c => {
      let value = c.value || c.id;
      let name = c.label || c.name || c.fantasyName || `${t('NAME_NOT_FOUND')}, id=${value}`;

      return {
        label: name,
        value: value
      }
    });
  }
  
  const [itemsSelected, setSelectedItems] = useState(mapItemsToLabelValue(selectedItems));
  const [menuIsOpen, setMenuIsOpen] = useState(openMenu);
  const [options, setOptions] = useState([]);
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if(fetchItems === null || fetchItems === undefined) return;
    (async () => {
      const { data, status } = await fetchItems();

      let tempData = data;
      if(interceptRequest && status >= 200 && status <= 299) {
        tempData = interceptRequest(data);
      }

      if(viewOnlyItemsId && viewOnlyItemsId.length) {
        tempData = tempData.filter(t => viewOnlyItemsId.includes(t.id));
      }

      setOptions(mapItemsToLabelValue(tempData));
    })();

  }, [fetchItems])

  useEffect(() => {
    setSelectedItems(mapItemsToLabelValue(selectedItems));
  }, [selectedItems])

  const onMenuOpen = () => {
    setMenuIsOpen(true);
  };

  const onMenuClose = () => {
    setMenuIsOpen(false);
  };

  const onRemovedSelectedOption = (item, props) => {
    let temp = Array.isArray(itemsSelected) ? itemsSelected.filter(f => f.value !== item.value) : [];
    setSelectedItems(temp);

    if(onSelect) {
      onSelect(temp);
    }
  }

  const onChangeSelectedItems = (selected, {action}) => {
    setSelectedItems(selected);

    if(onSelect) {
      onSelect(selected);
    }
  }

  const CustomOption = props => {
    let val = props.data;
    return (
      <components.Option {...props} >
        { !isGroupSelection ? 
          <Checkbox id={val.value} label={val.label} isChecked={false} callBack={() => {/**/ }} /> : 
          <div className={styles.groupOptionsStyles}>  {val.label}  </div>
        } 
      </components.Option>
    );
  };

  const CustomMenu = props => {
    return (
      <components.Menu {...props}>{props.children}</components.Menu>
    );
  }

  const CustomMenuList = props => {
    const values = props.hasValue ? props.getValue() : [];

    return (
        <components.MenuList {...props}>
          {
            values.length <= 0 ? null :
              <div className={styles.multiSelect}>
                <h1 className={styles.filterTitle}>Filtros salvos</h1>
                {values.map(val => {
                  return <div key={val.value} onClick={() => onRemovedSelectedOption(val, props)}>
                          <Checkbox id={val.value} label={val.label} isChecked={true} callBack={() => {/**/}} />
                        </div>
                })}
              </div>
          }
          {props.children}
        </components.MenuList>
    );
  };

  const CustomMultiValue = (props) => {
    return <></>
  }

  const CustomDropdownIndicator = props => {
    const values = props.hasValue ? props.getValue() : [];

    return (
      <div className={[styles.containerIndicators].join(' ')}>
          {
            values.length <= 0 ? null :
              <div className={[styles.indicatorSelected].join(' ')}>
                {values.length <= 10 ? values.length : '+10'}
              </div>
          }
          <components.DropdownIndicator {...props}/>
      </div>
    );
  };

  const CustomIndicatorSeparator = ({ innerProps }) => {
    return <></>;
  };

  const GroupHeading = props => (
    <components.GroupHeading {...props} className={styles.groupHeadingStyles} />
);

  const onChange = (value, { action }) => {
    switch(action) {
      case 'input-change':
        setInputValue(value);
        break;
      case 'menu-close':
        onMenuOpen();
        break;
      default:
          return;
    }
  }

  return (
    <div 
      className={styles.wrapper}
    >
      <label className={styles.label} htmlFor="input">
        {title}
      </label>
      <Select 
        styles={customStyles}
        options={options}
        value={itemsSelected}
        onChange={onChangeSelectedItems}
        menuIsOpen={menuIsOpen}
        onMenuOpen={onMenuOpen}
        onInputChange={onChange}
        inputValue={inputValue}
        onMenuClose={onMenuClose}
        isClearable={false}
        backspaceRemovesValue={false}
        noOptionsMessage={() => 'Nenhum resultado encontrado.'}
        placeholder={placeHolder}
        closeMenuOnSelect={closeOnSelect}
        openMenuOnFocus={true}
        blurInputOnSelect={false}
        isMulti={isMultiple}
        isDisabled={disabled || false}
        components={{
          Option: CustomOption,
          MenuList: CustomMenuList,
          Menu: CustomMenu,
          MultiValue: CustomMultiValue,
          DropdownIndicator: CustomDropdownIndicator,
          IndicatorSeparator: CustomIndicatorSeparator,
          GroupHeading
        }}
      />
    </div>
  );
}

export default MultiSelectStatic;
